/**
 * Copyright © 2025-2026 Cognizant Digital Business, Evolutionary AI.
 * All Rights Reserved.
 */
// END COPYRIGHT
// Adapted from neuro-san-ui packages/ui-common/controller/llm/Providers.ts
import { API_BASE_URL } from "../apiConfig";
/**
 * Every provider the user can bring a key for. This is the only place to add one: the dialog,
 * the stored-key lookup, key validation, and the types below all read from here.
 */
export const PROVIDERS = [
    { vendor: "OpenAI", field: "openai_api_key", placeholder: "sk-..." },
    { vendor: "Anthropic", field: "anthropic_api_key", placeholder: "sk-ant-..." },
    { vendor: "Google", field: "google_api_key", placeholder: "AIza..." },
];
export const isKeyValidationFailure = (result) => !result.ok;
const SERVER_UNAVAILABLE = "The LMX server could not check the key.";
// The server explains a turned-down request in `detail`; a crash explains nothing
const serverRejection = async (res) => {
    try {
        const body = await res.json();
        const detail = typeof body === "object" && body !== null && "detail" in body ? body.detail : undefined;
        return typeof detail === "string" ? detail : SERVER_UNAVAILABLE;
    }
    catch {
        return SERVER_UNAVAILABLE;
    }
};
/**
 * Have the LMX server ask the provider whether a key is usable, so the user finds out here
 * rather than from a failed brainstorming run. The browser cannot ask the provider itself:
 * the served UI runs under a connect-src 'self' CSP.
 */
export const validateProviderKey = async (vendor, key) => {
    try {
        const res = await fetch(`${API_BASE_URL}/api/validate-key`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ vendor, key }),
        });
        if (!res.ok) {
            return { ok: false, status: res.status, message: await serverRejection(res) };
        }
        return await res.json();
    }
    catch (e) {
        return { ok: false, message: e instanceof Error ? e.message : String(e) };
    }
};
